import React, { useMemo } from "react";
import { useAuth } from "@rapid/contexts/AuthContext";
import { useCurrentWorkspace } from "@rapid/hooks/useCurrentWorkspace";
import { ExperimentProvider } from "@scripts/react/hooks/ExperimentContext";
import { ActivitiesProvider } from "@scripts/react/components/Activities/ActivitiesContext";
import { useDatabase } from "./database/DatabaseProvider";

export function RapidExperimentProvider({ children }: { children: React.ReactNode }) {
    const { user, guestUid } = useAuth();
    const { currentWorkspace } = useCurrentWorkspace();
    const groups = useMemo(
        () => (currentWorkspace?.id ? { workspace: currentWorkspace.id } : undefined),
        [currentWorkspace?.id]
    );

    return (
        <ExperimentProvider distinctId={user?.uid ?? guestUid ?? ""} groups={groups}>
            {children}
        </ExperimentProvider>
    );
}

export function RapidActivitiesProvider({ children }: { children: React.ReactNode }) {
    const { user } = useAuth();
    const { currentWorkspace } = useCurrentWorkspace();
    const database = useDatabase();

    return (
        <ActivitiesProvider
            workspaceId={currentWorkspace?.id ?? ""}
            userId={user?.uid ?? ""}
            database={database}
        >
            {children}
        </ActivitiesProvider>
    );
}
